module.exports = __webpack_public_path__ + "static/img/gm_open03.680f135c.png";